import { Base64Data } from 'models/Base64Data';
import { MimeTypes } from 'models/Base64Data/MimeTypes';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const stringFromCharCodeArray = (charCodeArray: any) => {
  const chunkSize = 65536;
  let result = '';
  for (let i = 0; i < charCodeArray.length; i += chunkSize) {
    const chunk = charCodeArray.slice(i, i + chunkSize);
    result += String.fromCharCode.apply(null, chunk);
  }
  return result;
};

export const arrayBufferToBase64 = (
  input: ArrayBuffer,
  mimeType: MimeTypes = MimeTypes.APPLICATION_PDF,
): string => {
  const unit8 = new Uint8Array(input);
  const binary = stringFromCharCodeArray(unit8);
  const base64 = btoa(binary);
  return `data:${mimeType}${Base64Data.BASE64_GLU}${base64}`;
};
